import styled from 'styled-components/macro';

export const ScTableHead = styled.div`
	display: table-header-group;
`;
